import React, { Component } from 'react';
import { Input, Button } from "reactstrap";
import DatePicker from "react-datepicker";
import Select from 'react-select';

import OrderCard from '../../components/OrderCard/OrderCard.jsx';
import { ToastContainer } from 'react-toastify';
import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Collapse,
    Paper
} from '@material-ui/core';

import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

import { ListOrderCompany } from '../../api/index';

class OrderListCompany extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            value: null,
            startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
            endDate: new Date(new Date().setHours(23, 59, 59, 999)),
            count: 0,
            
            dataListOrderCompany: null,
            sumsubtotal: null,
            
            // State baru untuk perusahaan
            sbfi: null,
            ipbpress: null,
            
            listStatus: [],
            companyId: "", // Dibuat kosong agar by default memanggil semua data
            
            // Dropdown disesuaikan
            sortby: [
                {
                    id: "",
                    value: "Semua",
                    label: "Semua Company"
                },
                {
                    id: 45,
                    value: "SBFI",
                    label: "SBFI"
                },
                {
                    id: 21,
                    value: "IPB Press",
                    label: "IPB Press"
                }
            ],
        }
    }

    fetchProduct = () => {
        this.setState({ isFetching: true })
        const date = moment(this.state.startDate).format('YYYY-MM-DD');
        const dateEnd = moment(this.state.endDate).format('YYYY-M-DD');

        const dateTimeStart = date + " 00:00:00";
        const dateTimeEnd = dateEnd + " 23:59:59";
        
        const content = {
            querysearch: this.state.value,
            startDate: dateTimeStart,
            endDate: dateTimeEnd,
            companyId: this.state.companyId, // Jika "", backend akan mengambil semua
            page: 1
        }

        ListOrderCompany(content).then(result => {
            this.setState({ 
                dataListOrderCompany: result.result, 
                isFetching: false, 
                count: result.result.length, 
                sumsubtotal: result.subtotal[0].total, 
                // Tangkap data SBFI dan IPB Press dari backend
                sbfi: result.transaksisbfi[0].total, 
                ipbpress: result.transaksipress[0].total 
            })
        }).catch(err => {
            console.error(err);
            this.setState({ isFetching: false });
        });
    }

    formatuang(amount) {
        if (amount === null || amount === undefined) {
            return 0;
        }
        let comadel = amount.toString().replace(/\,/g, '');
        let price = comadel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return price;
    }

    queryInputChangeHandler = (event) => {
        event.preventDefault();
        this.setState({ value: event.target.value, dataListOrderCompany: null }, () => {
            this.fetchProduct();
        })
    }

    handleChangeStart = (val) => {
        this.setState({ startDate: val, dataListOrderCompany: null }, () => {
            this.fetchProduct();
        })
    }

    handleChangeEnd = (val) => {
        this.setState({ endDate: val, dataListOrderCompany: null }, () => {
            this.fetchProduct();
        })
    }

    handleExport = async () => {
        if (!this.state.dataListOrderCompany) return;
        const data = [];
        this.state.dataListOrderCompany.forEach((value) => {
            data.push({
                'Invoice' : value.transactionId,
                'Produk' : value.name,
                'Bank' : value.Order?.Bank?.bankname || '-',
                'Harga' : value.price,
                'Qty' : value.qty,
                'Sub Total' : value.subtotal,
                'Tanggal Transaksi' : value.createdAt,
                'Company' : value.Company?.companyName || '-'
            });          
        })
        const ws = utils.json_to_sheet(data);
        const wb2 = utils.book_new();
        utils.book_append_sheet(wb2, ws, "Data");
        writeFileXLSX(wb2, "ReportPenjualan.xlsx");
    }

    onSortByHandler = (val) => {
        // Jika user melakukan clear dropdown, tangkap nilainya sebagai string kosong
        let selectedId = val ? val.id : ""; 
        this.setState({ companyId: selectedId }, () => {
            this.fetchProduct();
        });
    }

    componentDidMount() {
        this.fetchProduct();
    }

    renderTable = () => {
        const Row = (props) => {
            const { data } = props;
            const [open, setOpen] = React.useState(false);

            return <>
                <TableRow onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
                    <TableCell>{data.transactionId}</TableCell>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.Order?.Bank?.bankname}</TableCell>
                    <TableCell>{this.formatuang(data.price)}</TableCell>
                    <TableCell>{data.qty}</TableCell>
                    <TableCell>{this.formatuang(data.subtotal)}</TableCell>
                    <TableCell>{moment(data.createdAt).format('YYYY-MM-DD HH:mm')}</TableCell>
                    {/* <TableCell>{data.Company?.companyName}</TableCell> */}
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <OrderCard history={this.props.history} OrderProps={data}></OrderCard>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        }
        
        const rows = this.state.dataListOrderCompany.map((value, index) => {
            return <Row key={index} data={value}></Row>
        })

        return (
            <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Invoice</TableCell>
                            <TableCell>Produk</TableCell>
                            <TableCell>Bank</TableCell>
                            <TableCell>Harga</TableCell>
                            <TableCell>Jumlah</TableCell>
                            <TableCell>Total</TableCell>
                            <TableCell>Tanggal Transaksi</TableCell>
                            {/* <TableCell>Company</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    render() {
        let ListOrderCompany = <>
            <div className="loading-background" style={{ width: '100%', height: '40px', marginTop: '10px' }}></div>
            <div className="loading-background" style={{ width: '100%', height: '40px', marginTop: '10px' }}></div>
            <div className="loading-background" style={{ width: '100%', height: '40px', marginTop: '10px' }}></div>
        </>

        if (this.state.dataListOrderCompany !== null) {
            ListOrderCompany = this.renderTable()
        }

        return (
            <>
                <ToastContainer />
                <div className="content">
                    <div className="otd-wrapper">
                        <div className="otd-header-wrapper">
                            <div className="search-input-wrap">
                                <Input onChange={(event) => { this.queryInputChangeHandler(event) }} placeholder="Cari Produk"></Input>
                            </div>
                            <div className="count">
                                <Select
                                    onChange={(val) => this.onSortByHandler(val)}
                                    name="sortby"
                                    placeholder="Pilih Company"
                                    className="basic-multi-select"
                                    options={this.state.sortby}
                                    defaultValue={this.state.sortby[0]} // Set default tampil ke "Semua Company"
                                />
                            </div>
                            <div className="date-input-filter">
                                <label style={{ padding: '0px 10px' }}><i className="nc-icon nc-calendar-60" /></label>
                                <DatePicker
                                    className="form-control datepicker-input"
                                    selected={this.state.startDate}
                                    dateFormat="dd-MM-yyyy"
                                    selectsStart
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    onChange={(val) => this.handleChangeStart(val)}
                                />
                                <span style={{ padding: '0px 10px' }}>-</span>
                                <DatePicker
                                    className="form-control datepicker-input"
                                    selected={this.state.endDate}
                                    dateFormat="dd-MM-yyyy"
                                    selectsEnd
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    onChange={(val) => this.handleChangeEnd(val)}
                                />
                            </div>
                        </div>
                        
                        <div className="list-status-class" style={{ marginBottom: '15px', fontWeight: 'bold' }}>
                            Total : {this.formatuang(this.state.sumsubtotal)} | 
                            SBFI : {this.formatuang(this.state.sbfi)} | 
                            IPB Press : {this.formatuang(this.state.ipbpress)}
                        </div>
                        
                        {ListOrderCompany}
                    </div>
                    <Button color="primary" onClick={() => this.handleExport()} style={{ marginTop: '15px' }}>Export Excel</Button>
                </div>
            </>
        )
    }
}

export default OrderListCompany;